export default __webpack_public_path__ + "static/media/slider3.16bf933f.jpeg";